import RecentSearches from './RecentSearches.component';

export default RecentSearches;
